<template lang='pug'>
  p.variant-count(
    v-if='product.attributes["variants-count"] > 1'
    v-text='`${product.attributes["variants-count"]} ${productOptionType}s`'
  )
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    productOptionType () {
      return this.product.attributes['option-type-categories'][0] || 'type'
    }
  }
}
</script>

<style lang='scss' scoped>
  .variant-count {
    color: $grey-dark;
  }
</style>
